 import React, { useState, useEffect ,useRef,useImperativeHandle } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import ModalEditar from './ModalEditar'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import '../../shared/components/button/buttonDemo.scss';
import { useGlobalContext } from "../../shared/context/global.context";
import { deleteComercioContacto } from '../services/comercio.service';

const TablaContactos = (props) => {
    const[modal, setModal]=useState(false)
    const {comercioSelecionado} = useGlobalContext()
    const [visible, setVisible] = useState(false);
    const toast =  useRef(null)


    const accept = async (rowData) => {
        const { data, status } = await deleteComercioContacto(comercioSelecionado[0].comercioId, rowData.id);    
        if (status === 200) {
            toast.current.show({ severity: 'info', summary: 'Confirmado', detail: 'Contacto eliminado exitosamente', life: 3000 });
            props.reloadContacts();
        }
    }

    const reject = () => {
        toast.current.show({ severity: 'warn', summary: 'Cancelado', detail: 'Operacion cancelada', life: 3000 });
    }

    const confirm1 = (rowData) => {
        confirmDialog({
            rejectLabel : 'cancelar',
            acceptLabel : 'aceptar',
            message: 'Está seguro de eliminar el contacto ?',
            header: 'Eliminar',
            icon: 'pi pi-exclamation-triangle',
            accept:()=>accept(rowData),
            reject
        });
    }


    const actionBodyTemplate = (rowData) => {
         return (
            <React.Fragment>
                <div style={{alignContent:'center'}} > 
                <Button className="p-button-rounded p-button-text" aria-label="Filter"onClick={() => props.handleModify(rowData)}  tooltip="Editar">
                    <i className="pi pi-pencil mr-2"></i>
                </Button>
                <Button className="p-button-rounded p-button-text" aria-label="Filter"onClick={() => confirm1(rowData)}  tooltip="Eliminar">
                    <i className="pi pi-trash"></i>
                </Button>
                </div>
            </React.Fragment>
        );
    }
 
    return (

        <div style={{paddingTop:"1rem"}}> 
        <div style={{justifyContent:"flex-end", alignItems:"end", display:"flex", paddingRight:"1rem"}}>
        </div>
        <Toast ref={toast} position="bottom-right"  />
        <ConfirmDialog />
         {modal && <ModalEditar /> }  
        <div >
            <DataTable value={props.contactos} responsiveLayout="scroll">
                <Column field="nombre" header="Nombre"></Column>
                <Column field="apellido" header="Apellido"></Column>
                <Column field="tipoContacto" header="Tipo"></Column>
                <Column field="email" header="Email"></Column>
                <Column field="telefono" header="Teléfono"></Column>
                <Column header='Acciones'body={actionBodyTemplate} exportable={false} style={{ minWidth: '8rem' }}></Column>
            </DataTable>
        </div>
        </div>
    );
};

export default TablaContactos;